import { ReactNode, useEffect } from "react";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { Box, Container, ThemeProvider } from "@mui/material";
import { theme } from "../../shared/util/Theme";

export function PlayerLayout({
  backgroundColor,
  foregroundColor,
  children,
}: {
  backgroundColor: string;
  foregroundColor: string;
  children: ReactNode | ReactNode[];
}) {
  document.body.style.background = backgroundColor;
  document.body.style.color = foregroundColor;
  useEffect(() => {
    const to = setTimeout(() => {
      document.body.style.transition = "background 1s, color 1s";
    }, 10);
    return () => clearTimeout(to);
  }, [backgroundColor, foregroundColor]);
  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth={"md"}>
        <Box
          sx={{
            textAlign: "left",
            position: "absolute",
            zIndex: 1000000,
            background: backgroundColor,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            // backgroundColor: backgroundColor,
            minHeight: "100vh",
          }}
        >
          {children}
        </Box>
      </Container>
    </ThemeProvider>
  );
}
